// src/api/kpi/useKPIAPI.js
import { createAPI } from '../../composable/useAPI';
const api = createAPI();

export const KPIService = {
  percentage: {
    async defectRate(params) {
      const res = await api.get('/api/v2/kpi/defectRate', { params });
      return res.data.data;
    },
    async deliveryComplianceRate(params) {
      const res = await api.get('/api/v2/kpi/deliveryComplianceRate', { params });
      return res.data.data;
    },
    async deliveryCompliance(params) {
      const res = await api.get('/api/v2/kpi/deliveryCompliance', { params });
      return res.data.data;
    },
  },
  TimeSeries: {
    async productionByProduct(params) {
      const res = await api.get('/api/v2/kpi/productionByProduct', { params });
      return res.data.data;
    },
    async readTime(params) {
      const res = await api.get('/api/v2/kpi/readTime', { params });
      return res.data.data;
    },
    async materialStockPrice(params) {
      const res = await api.get('/api/v2/kpi/materialStockPrice', { params });
      return res.data.data;
    },
    async operationTime(params) {
      const res = await api.get('/api/v2/kpi/operationTime', { params });
      return res.data.data;
    },
    async operationRate(params) {
      const res = await api.get('/api/v2/kpi/operationRate', { params });
      return res.data.data;
    },
    async externalData(params) {
      const res = await api.get('/api/v2/kpi/external', { params });
      return res.data.data;
    }
  },
  async indicators(params) {
    const res = await api.get('/api/v2/kpi/indicators', { params });
    return res.data.data;
  },
};
